import { MfNodeAttr } from "../node/MfNodeAttr";

/* eslint no-restricted-syntax: "off" */
/* eslint no-await-in-loop: "off" */

export const execValidators = async (node: MfNodeAttr): Promise<void> => {
  for (const validator of node.validators) {
    await validator.test(node);
  }
};
